import { Component, Vue } from 'vue-property-decorator';
import { Breadcrumbs } from './types';

@Component
export default class PageOrganizationsCommon extends Vue {
  get breadcrumbs(): Breadcrumbs {
		return [{
      text: 'Главная',
      to: { path: '/' },
    }];
  }
}



// WEBPACK FOOTER //
// ./src/pages/organizations/common.ts